@if (!editMode || editReadOnly) {
  <div>
    @if (showType) {
      <span>{{ displayOddsType }}:</span>
    }
    {{ displayOddsValue }}
  </div>
} @else {
  @if (internalFormGroup) {
    <form [formGroup]="internalFormGroup" class="main-form-container">
      <div class="elements">
        @if (showType) {
          <div class="type-options">
            <mat-select formControlName="type" class="select-box">
              @for (option of options; track option) {
                <mat-option [value]="option">
                  {{ option }}
                </mat-option>
              }
            </mat-select>
          </div>
        }
        <div class="info-container">
          <mat-form-field>
            <input
              formControlName="value"
              type="text"
              pattern="{{ '[0-9]{' + this.numberOfDecimalPlaces + '}' }}"
              matInput />
          </mat-form-field>
        </div>
      </div>
    </form>
  }
}
